<template>
  <vx-card :title="society.name">
    <vs-table max-items="10" pagination stripe :data="performanceData">
      <template slot="thead">
        <vs-th>Source/Medium</vs-th>
        <vs-th><span class="txt_align_right w-full">Utilisateurs</span></vs-th>
        <vs-th v-if="hasComparison"></vs-th>
        <vs-th
          ><span class="txt_align_right w-full">Nvx Utilisateurs</span></vs-th
        >
        <vs-th v-if="hasComparison"></vs-th>
        <vs-th>
          <vx-tooltip
            title="Sessions"
            text="Nombre de visites effectuées sur votre site."
            position="top"
            class="w-full txt_align_right"
          >
            <span>Sessions</span>
          </vx-tooltip>
        </vs-th>
        <vs-th v-if="hasComparison"></vs-th>
        <vs-th>
          <vx-tooltip
            title="Tx de rebond"
            text="Pourcentage de sessions pour lesquels le nombre de pages vues est égal à 1 (l’utilisateur est arrivé sur votre site, puis il est reparti, sans cliquer sur un lien interne ; il n’a pas chargé d’autre page sur votre site)."
            position="top"
            class="w-full txt_align_right"
          >
            <span>Tx de rebond</span>
          </vx-tooltip>
        </vs-th>
        <vs-th v-if="hasComparison"></vs-th>
        <vs-th>
          <vx-tooltip
            title="Page/session"
            text="Ratio entre le nombre de pages vues et le nombre de sessions."
            position="top"
            class="w-full txt_align_right"
          >
            <span>Page/session</span>
          </vx-tooltip>
        </vs-th>
        <vs-th v-if="hasComparison"></vs-th>
        <vs-th>
          <vx-tooltip
            title="Durée moyenne"
            text="/!\ Google Analytics ne prend donc en compte que les sessions qui comportent au moins deux pages vues. Moralité : plus votre taux de rebond est élevé, moins la durée moyenne des sessions correspond à la réalité."
            position="top"
            class="w-full txt_align_right"
          >
            <span>Durée moyenne</span>
          </vx-tooltip>
        </vs-th>
        <vs-th v-if="hasComparison"></vs-th>
        <vs-th v-if="society.is_ecommerce == 1">
          <vx-tooltip
            title="Tx de conversion"
            text="Ratio entre le nombre de conversions (quantité d’achats) et les sessions."
            position="top"
            class="w-full txt_align_right"
          >
            <span>Tx de conversion</span>
          </vx-tooltip>
        </vs-th>
        <vs-th v-if="hasComparison && society.is_ecommerce == 1"></vs-th>
        <vs-th v-if="society.is_ecommerce == 1">
          <vx-tooltip
            title="Transactions"
            text="Nombre de transactions (e-commerce) enregistrées sur la période définie."
            position="top"
            class="w-full txt_align_right"
          >
            <span>Transactions</span>
          </vx-tooltip>
        </vs-th>
        <vs-th v-if="hasComparison && society.is_ecommerce == 1"></vs-th>
        <vs-th v-if="society.is_ecommerce == 1">
          <vx-tooltip
            title="Chiffre d'affaire"
            text="Chiffre d’affaires (e-commerce) réalisé sur la période définie."
            position="top"
            class="w-full txt_align_right"
          >
            <span>Chiffre d'affaire</span>
          </vx-tooltip>
        </vs-th>
        <vs-th v-if="hasComparison && society.is_ecommerce == 1"></vs-th>
      </template>

      <template slot-scope="{ data }">
        <!-- GLOBAL DATA -->
        <vs-tr style="background-color:#35e9fd !important;">
          <vs-td></vs-td>
          <!-- USER BLOCK -->
          <vs-td class="global_value txt_align_right">
            {{ formatThousandNumb(performanceGlobalData[0]) }}
            <div
              class="global_value txt_align_right"
              v-if="hasComparison && comparisonGlobalData"
            >
              {{ formatThousandNumb(comparisonGlobalData[0]) }}
            </div>
          </vs-td>

          <vs-td v-if="hasComparison">
            <div class="vx-col">
              <div class="center">
                {{
                  getDiffPercent(
                    performanceGlobalData[0],
                    comparisonGlobalData[0]
                  )
                }}%
              </div>
              <div class="center">
                <feather-icon
                  :icon="
                    getSign(performanceGlobalData[0], comparisonGlobalData[0]) <
                    0
                      ? 'ArrowDownIcon'
                      : 'ArrowUpIcon'
                  "
                  :svgClasses="[
                    getSign(performanceGlobalData[0], comparisonGlobalData[0]) <
                    0
                      ? 'text-danger'
                      : 'text-success',
                    'stroke-current h-4 w-4 mb-1 mr-1'
                  ]"
                >
                </feather-icon>
              </div>
            </div>
          </vs-td>

          <!-- NEW USER BLOCK -->
          <vs-td class="global_value txt_align_right">
            {{ formatThousandNumb(performanceGlobalData[1]) }}
            <div
              class="global_value txt_align_right"
              v-if="hasComparison && comparisonGlobalData"
            >
              {{ formatThousandNumb(comparisonGlobalData[1]) }}
            </div>
          </vs-td>

          <vs-td v-if="hasComparison">
            <div class="vx-col">
              <div class="center">
                {{
                  getDiffPercent(
                    performanceGlobalData[1],
                    comparisonGlobalData[1]
                  )
                }}%
              </div>
              <div class="center">
                <feather-icon
                  :icon="
                    getSign(performanceGlobalData[1], comparisonGlobalData[1]) <
                    0
                      ? 'ArrowDownIcon'
                      : 'ArrowUpIcon'
                  "
                  :svgClasses="[
                    getSign(performanceGlobalData[1], comparisonGlobalData[1]) <
                    0
                      ? 'text-danger'
                      : 'text-success',
                    'stroke-current h-4 w-4 mb-1 mr-1'
                  ]"
                >
                </feather-icon>
              </div>
            </div>
          </vs-td>

          <!-- SESSIONS BLOCK -->
          <vs-td class="global_value txt_align_right">
            {{ formatThousandNumb(performanceGlobalData[2]) }}
            <div
              class="global_value txt_align_right"
              v-if="hasComparison && comparisonGlobalData"
            >
              {{ formatThousandNumb(comparisonGlobalData[2]) }}
            </div>
          </vs-td>

          <vs-td v-if="hasComparison">
            <div class="vx-col">
              <div class="center">
                {{
                  getDiffPercent(
                    performanceGlobalData[2],
                    comparisonGlobalData[2]
                  )
                }}%
              </div>
              <div class="center">
                <feather-icon
                  :icon="
                    getSign(performanceGlobalData[2], comparisonGlobalData[2]) <
                    0
                      ? 'ArrowDownIcon'
                      : 'ArrowUpIcon'
                  "
                  :svgClasses="[
                    getSign(performanceGlobalData[2], comparisonGlobalData[2]) <
                    0
                      ? 'text-danger'
                      : 'text-success',
                    'stroke-current h-4 w-4 mb-1 mr-1'
                  ]"
                >
                </feather-icon>
              </div>
            </div>
          </vs-td>

          <!-- BOUNCE RATE BLOCK -->
          <vs-td class="global_value txt_align_right">
            {{ formatValue(performanceGlobalData[3]) }}%
            <div
              class="global_value txt_align_right"
              v-if="hasComparison && comparisonGlobalData"
            >
              {{ formatValue(comparisonGlobalData[3]) }}%
            </div>
          </vs-td>

          <vs-td v-if="hasComparison">
            <div class="vx-col">
              <div class="center">
                {{
                  getDiffPercent(
                    performanceGlobalData[3],
                    comparisonGlobalData[3]
                  )
                }}%
              </div>
              <div class="center">
                <feather-icon
                  :icon="
                    getSign(performanceGlobalData[3], comparisonGlobalData[3]) <
                    0
                      ? 'ArrowDownIcon'
                      : 'ArrowUpIcon'
                  "
                  :svgClasses="[
                    getSign(performanceGlobalData[3], comparisonGlobalData[3]) <
                    0
                      ? 'text-danger'
                      : 'text-success',
                    'stroke-current h-4 w-4 mb-1 mr-1'
                  ]"
                >
                </feather-icon>
              </div>
            </div>
          </vs-td>

          <!-- PAGE/SESSION BLOCK -->
          <vs-td class="global_value txt_align_right">
            {{ formatValue(performanceGlobalData[4]) }}
            <div
              class="global_value txt_align_right"
              v-if="hasComparison && comparisonGlobalData"
            >
              {{ formatValue(comparisonGlobalData[4]) }}
            </div>
          </vs-td>

          <vs-td v-if="hasComparison">
            <div class="vx-col">
              <div class="center">
                {{
                  getDiffPercent(
                    performanceGlobalData[4],
                    comparisonGlobalData[4]
                  )
                }}%
              </div>
              <div class="center">
                <feather-icon
                  :icon="
                    getSign(performanceGlobalData[4], comparisonGlobalData[4]) <
                    0
                      ? 'ArrowDownIcon'
                      : 'ArrowUpIcon'
                  "
                  :svgClasses="[
                    getSign(performanceGlobalData[4], comparisonGlobalData[4]) <
                    0
                      ? 'text-danger'
                      : 'text-success',
                    'stroke-current h-4 w-4 mb-1 mr-1'
                  ]"
                >
                </feather-icon>
              </div>
            </div>
          </vs-td>

          <!-- SESSION DURATION BLOCK -->
          <vs-td class="global_value txt_align_right">
            {{ formatMsToMinuts(performanceGlobalData[5]) }}
            <div
              class="global_value txt_align_right"
              v-if="hasComparison && comparisonGlobalData"
            >
              {{ formatMsToMinuts(comparisonGlobalData[5]) }}
            </div>
          </vs-td>

          <vs-td v-if="hasComparison">
            <div class="vx-col">
              <div class="center">
                {{
                  getDiffPercent(
                    performanceGlobalData[5],
                    comparisonGlobalData[5]
                  )
                }}%
              </div>
              <div class="center">
                <feather-icon
                  :icon="
                    getSign(performanceGlobalData[5], comparisonGlobalData[5]) <
                    0
                      ? 'ArrowDownIcon'
                      : 'ArrowUpIcon'
                  "
                  :svgClasses="[
                    getSign(performanceGlobalData[5], comparisonGlobalData[5]) <
                    0
                      ? 'text-danger'
                      : 'text-success',
                    'stroke-current h-4 w-4 mb-1 mr-1'
                  ]"
                >
                </feather-icon>
              </div>
            </div>
          </vs-td>

          <!-- CONV RATE BLOCK -->
          <vs-td
            class="global_value txt_align_right"
            v-if="society.is_ecommerce == 1"
          >
            {{ formatValue(performanceGlobalData[6]) }}%
            <div
              class="global_value txt_align_right"
              v-if="hasComparison && comparisonGlobalData"
            >
              {{ formatValue(comparisonGlobalData[6]) }}%
            </div>
          </vs-td>

          <vs-td v-if="hasComparison && society.is_ecommerce == 1">
            <div class="vx-col">
              <div class="center">
                {{
                  getDiffPercent(
                    performanceGlobalData[6],
                    comparisonGlobalData[6]
                  )
                }}%
              </div>
              <div class="center">
                <feather-icon
                  :icon="
                    getSign(performanceGlobalData[6], comparisonGlobalData[6]) <
                    0
                      ? 'ArrowDownIcon'
                      : 'ArrowUpIcon'
                  "
                  :svgClasses="[
                    getSign(performanceGlobalData[6], comparisonGlobalData[6]) <
                    0
                      ? 'text-danger'
                      : 'text-success',
                    'stroke-current h-4 w-4 mb-1 mr-1'
                  ]"
                >
                </feather-icon>
              </div>
            </div>
          </vs-td>

          <!-- TRANSACTION BLOCK -->
          <vs-td
            class="global_value txt_align_right"
            v-if="society.is_ecommerce == 1"
          >
            {{ formatThousandNumb(performanceGlobalData[7]) }}
            <div
              class="global_value txt_align_right"
              v-if="hasComparison && comparisonGlobalData"
            >
              {{ formatThousandNumb(comparisonGlobalData[7]) }}
            </div>
          </vs-td>

          <vs-td v-if="hasComparison && society.is_ecommerce == 1">
            <div class="vx-col">
              <div class="center">
                {{
                  getDiffPercent(
                    performanceGlobalData[7],
                    comparisonGlobalData[7]
                  )
                }}%
              </div>
              <div class="center">
                <feather-icon
                  :icon="
                    getSign(performanceGlobalData[7], comparisonGlobalData[7]) <
                    0
                      ? 'ArrowDownIcon'
                      : 'ArrowUpIcon'
                  "
                  :svgClasses="[
                    getSign(performanceGlobalData[7], comparisonGlobalData[7]) <
                    0
                      ? 'text-danger'
                      : 'text-success',
                    'stroke-current h-4 w-4 mb-1 mr-1'
                  ]"
                >
                </feather-icon>
              </div>
            </div>
          </vs-td>

          <!-- REVENUE BLOCK -->
          <vs-td
            class="global_value txt_align_right"
            v-if="society.is_ecommerce == 1"
          >
            {{
              formatThousandNumb(formatValue(performanceGlobalData[8]))
            }}&nbsp;€
            <div
              class="global_value txt_align_right"
              v-if="hasComparison && comparisonGlobalData"
            >
              {{
                formatThousandNumb(formatValue(comparisonGlobalData[8]))
              }}&nbsp;€
            </div>
          </vs-td>

          <vs-td v-if="hasComparison && society.is_ecommerce == 1">
            <div class="vx-col">
              <div class="center">
                {{
                  getDiffPercent(
                    performanceGlobalData[8],
                    comparisonGlobalData[8]
                  )
                }}%
              </div>
              <div class="center">
                <feather-icon
                  :icon="
                    getSign(performanceGlobalData[8], comparisonGlobalData[8]) <
                    0
                      ? 'ArrowDownIcon'
                      : 'ArrowUpIcon'
                  "
                  :svgClasses="[
                    getSign(performanceGlobalData[8], comparisonGlobalData[8]) <
                    0
                      ? 'text-danger'
                      : 'text-success',
                    'stroke-current h-4 w-4 mb-1 mr-1'
                  ]"
                >
                </feather-icon>
              </div>
            </div>
          </vs-td>
        </vs-tr>

        <!-- ALL DATA -->
        <vs-tr :key="index" v-for="(tr, index) in data">
          <!-- SOURCE/MEDIUM BLOCK -->
          <vs-td :data="tr">
            {{ formatString(tr.dimensions[0], 35) }}
            <div v-if="hasComparison">{{ fromDate }} - {{ toDate }}</div>
            <div v-if="hasComparison">
              {{ comparingFromDate }} - {{ comparingToDate }}
            </div>
          </vs-td>

          <!-- Representation of 1 block -->
          <!-- USER BLOCK -->
          <vs-td :data="tr.metrics[0].values[0]" class="txt_align_right">
            {{ formatThousandNumb(tr.metrics[0].values[0]) }}
            ({{
              formatValue(
                getValueInPercent(
                  tr.metrics[0].values[0],
                  performanceGlobalData[0]
                )
              )
            }}%)
            <vs-progress
              :percent="
                Number(
                  getValueInPercent(
                    tr.metrics[0].values[0],
                    performanceGlobalData[0]
                  )
                )
              "
            >
            </vs-progress>
            <div v-if="hasComparison">
              {{ formatThousandNumb(tr.metrics[1].values[0]) }}
              ({{
                formatValue(
                  getValueInPercent(
                    tr.metrics[1].values[0],
                    comparisonGlobalData[0]
                  )
                )
              }}%)
              <vs-progress
                color="success"
                :percent="
                  Number(
                    getValueInPercent(
                      tr.metrics[1].values[0],
                      comparisonGlobalData[0]
                    )
                  )
                "
              >
              </vs-progress>
            </div>
          </vs-td>
          <vs-td :data="tr.metrics[0].values[0]" v-if="hasComparison">
            <div class="vx-col">
              <div class="center">
                {{
                  getDiffPercent(
                    tr.metrics[0].values[0],
                    tr.metrics[1].values[0]
                  )
                }}%
              </div>
              <div class="center">
                <feather-icon
                  :icon="
                    getDiffPercent(
                      tr.metrics[0].values[0],
                      tr.metrics[1].values[0]
                    ) < 0
                      ? 'ArrowDownIcon'
                      : 'ArrowUpIcon'
                  "
                  :svgClasses="[
                    getDiffPercent(
                      tr.metrics[0].values[0],
                      tr.metrics[1].values[0]
                    ) < 0
                      ? 'text-danger'
                      : 'text-success',
                    'stroke-current h-4 w-4 mb-1 mr-1'
                  ]"
                >
                </feather-icon>
              </div>
            </div>
          </vs-td>
          <!-- End of the block -->

          <!-- NEW USER BLOCK -->
          <vs-td :data="tr" class="txt_align_right">
            {{ formatThousandNumb(tr.metrics[0].values[1]) }}
            ({{
              formatValue(
                getValueInPercent(
                  tr.metrics[0].values[1],
                  performanceGlobalData[1]
                )
              )
            }}%)
            <vs-progress
              :percent="
                Number(
                  getValueInPercent(
                    tr.metrics[0].values[1],
                    performanceGlobalData[1]
                  )
                )
              "
            >
            </vs-progress>
            <div v-if="hasComparison">
              {{ formatThousandNumb(tr.metrics[1].values[1]) }}
              ({{
                formatValue(
                  getValueInPercent(
                    tr.metrics[1].values[1],
                    comparisonGlobalData[1]
                  )
                )
              }}%)
              <vs-progress
                color="success"
                :percent="
                  Number(
                    getValueInPercent(
                      tr.metrics[1].values[1],
                      comparisonGlobalData[1]
                    )
                  )
                "
              >
              </vs-progress>
            </div>
          </vs-td>

          <vs-td :data="tr.metrics[0].values[0]" v-if="hasComparison">
            <div class="vx-col">
              <div class="center">
                {{
                  getDiffPercent(
                    tr.metrics[0].values[1],
                    tr.metrics[1].values[1]
                  )
                }}%
              </div>
              <div class="center">
                <feather-icon
                  :icon="
                    getDiffPercent(
                      tr.metrics[0].values[1],
                      tr.metrics[1].values[1]
                    ) < 0
                      ? 'ArrowDownIcon'
                      : 'ArrowUpIcon'
                  "
                  :svgClasses="[
                    getDiffPercent(
                      tr.metrics[0].values[1],
                      tr.metrics[1].values[1]
                    ) < 0
                      ? 'text-danger'
                      : 'text-success',
                    'stroke-current h-4 w-4 mb-1 mr-1'
                  ]"
                >
                </feather-icon>
              </div>
            </div>
          </vs-td>

          <!-- SESSIONS BLOCK -->
          <vs-td :data="tr" class="txt_align_right">
            {{ formatThousandNumb(tr.metrics[0].values[2]) }}
            ({{
              formatValue(
                getValueInPercent(
                  tr.metrics[0].values[2],
                  performanceGlobalData[2]
                )
              )
            }}%)
            <vs-progress
              :percent="
                Number(
                  getValueInPercent(
                    tr.metrics[0].values[2],
                    performanceGlobalData[2]
                  )
                )
              "
            >
            </vs-progress>
            <div v-if="hasComparison">
              {{ formatThousandNumb(tr.metrics[1].values[2]) }}
              ({{
                formatValue(
                  getValueInPercent(
                    tr.metrics[1].values[2],
                    comparisonGlobalData[2]
                  )
                )
              }}%)
              <vs-progress
                color="success"
                :percent="
                  Number(
                    getValueInPercent(
                      tr.metrics[1].values[2],
                      comparisonGlobalData[2]
                    )
                  )
                "
              >
              </vs-progress>
            </div>
          </vs-td>

          <vs-td :data="tr.metrics[0].values[0]" v-if="hasComparison">
            <div class="vx-col">
              <div class="center">
                {{
                  getDiffPercent(
                    tr.metrics[0].values[2],
                    tr.metrics[1].values[2]
                  )
                }}%
              </div>
              <div class="center">
                <feather-icon
                  :icon="
                    getDiffPercent(
                      tr.metrics[0].values[2],
                      tr.metrics[1].values[2]
                    ) < 0
                      ? 'ArrowDownIcon'
                      : 'ArrowUpIcon'
                  "
                  :svgClasses="[
                    getDiffPercent(
                      tr.metrics[0].values[2],
                      tr.metrics[1].values[2]
                    ) < 0
                      ? 'text-danger'
                      : 'text-success',
                    'stroke-current h-4 w-4 mb-1 mr-1'
                  ]"
                >
                </feather-icon>
              </div>
            </div>
          </vs-td>

          <!-- BOUNCE RATE BLOCK -->
          <vs-td :data="tr" class="txt_align_right">
            {{ formatValue(tr.metrics[0].values[3]) }}%
            <!--({{ formatValue(getValueInPercent(tr.metrics[0].values[3], 3)) }}%)-->
            <div v-if="hasComparison">
              {{ formatValue(tr.metrics[1].values[3]) }}%
            </div>
          </vs-td>

          <vs-td :data="tr.metrics[0].values[0]" v-if="hasComparison">
            <div class="vx-col">
              <div class="center">
                {{
                  getDiffPercent(
                    tr.metrics[0].values[3],
                    tr.metrics[1].values[3]
                  )
                }}%
              </div>
              <div class="center">
                <feather-icon
                  :icon="
                    getDiffPercent(
                      tr.metrics[0].values[3],
                      tr.metrics[1].values[3]
                    ) < 0
                      ? 'ArrowDownIcon'
                      : 'ArrowUpIcon'
                  "
                  :svgClasses="[
                    getDiffPercent(
                      tr.metrics[0].values[3],
                      tr.metrics[1].values[3]
                    ) < 0
                      ? 'text-danger'
                      : 'text-success',
                    'stroke-current h-4 w-4 mb-1 mr-1'
                  ]"
                >
                </feather-icon>
              </div>
            </div>
          </vs-td>

          <!-- PAGE/SESSION BLOCK -->
          <vs-td :data="tr" class="txt_align_right">
            {{ formatValue(tr.metrics[0].values[4]) }}
            <!--({{ formatValue(getValueInPercent(tr.metrics[0].values[4], 4)) }}%)-->
            <div v-if="hasComparison">
              {{ formatValue(tr.metrics[1].values[4]) }}
            </div>
          </vs-td>

          <vs-td :data="tr.metrics[0].values[0]" v-if="hasComparison">
            <div class="vx-col">
              <div class="center">
                {{
                  getDiffPercent(
                    tr.metrics[0].values[4],
                    tr.metrics[1].values[4]
                  )
                }}%
              </div>
              <div class="center">
                <feather-icon
                  :icon="
                    getDiffPercent(
                      tr.metrics[0].values[4],
                      tr.metrics[1].values[4]
                    ) < 0
                      ? 'ArrowDownIcon'
                      : 'ArrowUpIcon'
                  "
                  :svgClasses="[
                    getDiffPercent(
                      tr.metrics[0].values[4],
                      tr.metrics[1].values[4]
                    ) < 0
                      ? 'text-danger'
                      : 'text-success',
                    'stroke-current h-4 w-4 mb-1 mr-1'
                  ]"
                >
                </feather-icon>
              </div>
            </div>
          </vs-td>

          <!-- SESSION DURATION BLOCK -->
          <vs-td :data="tr" class="txt_align_right">
            {{ formatMsToMinuts(tr.metrics[0].values[5]) }}
            <div v-if="hasComparison">
              {{ formatMsToMinuts(tr.metrics[1].values[5]) }}
            </div>
          </vs-td>

          <vs-td :data="tr.metrics[0].values[0]" v-if="hasComparison">
            <div class="vx-col">
              <div class="center">
                {{
                  getDiffPercent(
                    tr.metrics[0].values[5],
                    tr.metrics[1].values[5]
                  )
                }}%
              </div>
              <div class="center">
                <feather-icon
                  :icon="
                    getDiffPercent(
                      tr.metrics[0].values[5],
                      tr.metrics[1].values[5]
                    ) < 0
                      ? 'ArrowDownIcon'
                      : 'ArrowUpIcon'
                  "
                  :svgClasses="[
                    getDiffPercent(
                      tr.metrics[0].values[5],
                      tr.metrics[1].values[5]
                    ) < 0
                      ? 'text-danger'
                      : 'text-success',
                    'stroke-current h-4 w-4 mb-1 mr-1'
                  ]"
                >
                </feather-icon>
              </div>
            </div>
          </vs-td>

          <!-- CONV RATE BLOCK -->
          <vs-td
            :data="tr"
            class="txt_align_right"
            v-if="society.is_ecommerce == 1"
          >
            {{ formatValue(tr.metrics[0].values[6]) }}%
            <div v-if="hasComparison">
              {{ formatValue(tr.metrics[1].values[6]) }}%
            </div>
          </vs-td>

          <vs-td
            :data="tr.metrics[0].values[0]"
            v-if="hasComparison && society.is_ecommerce == 1"
          >
            <div class="vx-col">
              <div class="center">
                {{
                  getDiffPercent(
                    tr.metrics[0].values[6],
                    tr.metrics[1].values[6]
                  )
                }}%
              </div>
              <div class="center">
                <feather-icon
                  :icon="
                    getDiffPercent(
                      tr.metrics[0].values[6],
                      tr.metrics[1].values[6]
                    ) < 0
                      ? 'ArrowDownIcon'
                      : 'ArrowUpIcon'
                  "
                  :svgClasses="[
                    getDiffPercent(
                      tr.metrics[0].values[6],
                      tr.metrics[1].values[6]
                    ) < 0
                      ? 'text-danger'
                      : 'text-success',
                    'stroke-current h-4 w-4 mb-1 mr-1'
                  ]"
                >
                </feather-icon>
              </div>
            </div>
          </vs-td>

          <!-- CONVERSION BLOCK -->
          <vs-td
            :data="tr"
            class="txt_align_right"
            v-if="society.is_ecommerce == 1"
          >
            {{ tr.metrics[0].values[7] }}
            ({{
              formatValue(
                getValueInPercent(
                  tr.metrics[0].values[7],
                  performanceGlobalData[7]
                )
              )
            }}%)
            <vs-progress
              :percent="
                Number(
                  getValueInPercent(
                    tr.metrics[0].values[7],
                    performanceGlobalData[7]
                  )
                )
              "
            >
            </vs-progress>
            <div v-if="hasComparison && society.is_ecommerce == 1">
              {{ tr.metrics[1].values[7] }}
              ({{
                formatValue(
                  getValueInPercent(
                    tr.metrics[1].values[7],
                    comparisonGlobalData[7]
                  )
                )
              }}%)
              <vs-progress
                color="success"
                :percent="
                  Number(
                    getValueInPercent(
                      tr.metrics[1].values[7],
                      comparisonGlobalData[7]
                    )
                  )
                "
              >
              </vs-progress>
            </div>
          </vs-td>

          <vs-td
            :data="tr.metrics[0].values[0]"
            v-if="hasComparison && society.is_ecommerce == 1"
          >
            <div class="vx-col">
              <div class="center">
                {{
                  getDiffPercent(
                    tr.metrics[0].values[7],
                    tr.metrics[1].values[7]
                  )
                }}%
              </div>
              <div class="center">
                <feather-icon
                  :icon="
                    getDiffPercent(
                      tr.metrics[0].values[7],
                      tr.metrics[1].values[7]
                    ) < 0
                      ? 'ArrowDownIcon'
                      : 'ArrowUpIcon'
                  "
                  :svgClasses="[
                    getDiffPercent(
                      tr.metrics[0].values[7],
                      tr.metrics[1].values[7]
                    ) < 0
                      ? 'text-danger'
                      : 'text-success',
                    'stroke-current h-4 w-4 mb-1 mr-1'
                  ]"
                >
                </feather-icon>
              </div>
            </div>
          </vs-td>

          <!-- REVENUE BLOCK -->
          <vs-td
            :data="tr"
            class="txt_align_right"
            v-if="society.is_ecommerce == 1"
          >
            {{
              formatThousandNumb(formatValue(tr.metrics[0].values[8], 2))
            }}&nbsp;€ ({{
              formatValue(
                getValueInPercent(
                  tr.metrics[0].values[8],
                  performanceGlobalData[8]
                )
              )
            }}%)
            <vs-progress
              :percent="
                Number(
                  getValueInPercent(
                    tr.metrics[0].values[8],
                    performanceGlobalData[8]
                  )
                )
              "
            >
            </vs-progress>
            <div v-if="hasComparison">
              {{
                formatThousandNumb(formatValue(tr.metrics[1].values[8]))
              }}&nbsp;€ ({{
                formatValue(
                  getValueInPercent(
                    tr.metrics[1].values[8],
                    comparisonGlobalData[8]
                  )
                )
              }}%)
              <vs-progress
                color="success"
                :percent="
                  Number(
                    getValueInPercent(
                      tr.metrics[1].values[8],
                      comparisonGlobalData[8]
                    )
                  )
                "
              >
              </vs-progress>
            </div>
          </vs-td>

          <vs-td
            :data="tr.metrics[0].values[0]"
            v-if="hasComparison && society.is_ecommerce == 1"
          >
            <div class="vx-col">
              <div class="center">
                {{
                  getDiffPercent(
                    tr.metrics[0].values[8],
                    tr.metrics[1].values[8]
                  )
                }}%
              </div>
              <div class="center">
                <feather-icon
                  :icon="
                    getDiffPercent(
                      tr.metrics[0].values[8],
                      tr.metrics[1].values[8]
                    ) < 0
                      ? 'ArrowDownIcon'
                      : 'ArrowUpIcon'
                  "
                  :svgClasses="[
                    getDiffPercent(
                      tr.metrics[0].values[8],
                      tr.metrics[1].values[8]
                    ) < 0
                      ? 'text-danger'
                      : 'text-success',
                    'stroke-current h-4 w-4 mb-1 mr-1'
                  ]"
                >
                </feather-icon>
              </div>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </vx-card>
</template>

<script>
import utilsMixin from "@/mixins/utilsMixin";

export default {
	name: "PerformanceTable",
	props: {
		society: Object,
		performanceData: Array,
		performanceGlobalData: Array,
		comparisonGlobalData: Array,
		fromDate: String, // DATE TO STRING
		toDate: String, // DATE TO STRING
		comparingToDate: String, // DATE TO STRING
		comparingFromDate: String, // DATE TO STRING
		hasComparison: Boolean
	},
	mixins: [utilsMixin]
};
</script>

<style scoped>
.center {
  display: flex;
  justify-content: center;
}

.bgcolor {
  background-color: #383080;
}

.global_value {
  font-size: px;
  font-weight: bold;
  color: black;
}

.txt_align_right {
  text-align: right;
}
.pointer {
  cursor: pointer;
}
</style>
